// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BKOFU","left":"styles_left__o5CCL","desktopActions":"styles_desktopActions__3pTjt","title":"styles_title__39II3"};